
export default {
  placeDetails: {
    layer: 'Ebene',
    lat: 'Lat.',
    lon: 'Lon.',
    notAvailable: 'Nicht verfügbar',
    placeDetails: 'Ort Details',
    placeName: 'Name',
    latlngCopied: 'Breiten- und Längengrad kopiert',
    lnglatCopied: 'Längen und Breitengrad kopiert',
    copyLatlng: 'Kopiere in Latitude,Longitude Format',
    copyLnglat: 'Kopiere in Longitude,Latitude Format',
    satelliteView: 'Satellitenbild'
  }
}
